<div class="card">
    <div class="card-header flex justify-between items-center">
      <div class="exp">
        <h4 class="text-lg font-semibold">Amazon Web Services India Private Limited taxes by service</h4>
        <div class="flex-jc">
        <div>
            <p>Total taxed services<br><strong>{{ taxedServices.length }}</strong></p>
        </div>
        <div>
            <p>Total tax in USD<br><strong>{{ getTotalTax() | number:'1.2-2' }}</strong></p>
        </div>
    </div>
      </div>
    </div>
  
    <div class="card-body">
      <div class="input-group mb-4 w-50 mt-4">
        <span class="input-group-text bg-white border-end-0">
          <i class="fa-solid fa-magnifying-glass text-muted"></i>
        </span>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          class="form-control border-start-0"
          placeholder="Filter by service name"
        />
      </div>
  
      <table class="table table-striped table-bordered table-hover">
        <thead class="thead-light">
          <tr>
            <th
              *ngFor="let header of headers"
              (click)="sortBy(header.key)"
              class="cursor-pointer"
            >
              {{ header.label }} ⬍
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let taxedService of filteredServices">
            <td *ngFor="let header of headers">
              {{ taxedService[header.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  